import { render, staticRenderFns } from "./Agents.vue?vue&type=template&id=79a6fcb1&scoped=true"
import script from "./Agents.vue?vue&type=script&lang=js"
export * from "./Agents.vue?vue&type=script&lang=js"
import style0 from "./Agents.vue?vue&type=style&index=0&id=79a6fcb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a6fcb1",
  null
  
)

export default component.exports